// extracted by mini-css-extract-plugin
module.exports = {"userDetailsCard":"UserDetailsCard_userDetailsCard__j4Z7F","insignia":"UserDetailsCard_insignia__kKVEn"};